import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-e-small', 'IconLetterESmall', [
  ['path', { d: 'M14 8h-4v8h4', key: 'svg-0' }],
  ['path', { d: 'M10 12h2.5', key: 'svg-1' }],
]);
